module.exports = __webpack_public_path__ + "img/img/girl-to-right.b898ba92.jpg";